<template>

  <v-row style="margin: auto;" justify="center">
    <v-row style="padding-bottom: 50px; margin-left: 100px;">
      <span style="color: #0A7EA5; font-size: 16px; cursor: pointer;" @click="getBackList()" class="hover-back">
        &lt;Back
      </span>
    </v-row>
    <v-row style="margin-left: -100px;">
      <v-card-title>

        <v-container class="pa-12">
          <v-card class="pl-16 pr-16 pt-8 pb-16">

            <v-card-title>

              <v-row>
                <v-col cols="6" md="6" justify="center">
                  <h3>Sales Order</h3>
                </v-col>
                <v-col cols="6" md="6">
                  <v-row>
                    <v-col class="text-right" cols="12" md="12">
                      <h5>No.</h5>
                      <h5>Date {{ dateCurrent }}</h5>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-card-title>
            <v-row class="row1 mt-3  pt-3 ">
              <v-col cols="12" md="2">
                <v-autocomplete v-model="customer_code" :items="customer" item-text="cust_account" item-value="id"
                  outlined @change="showCode" :disabled="sostatus" dense label="Client Code"></v-autocomplete>
              </v-col>
              <v-col cols="12" md="6">
                <v-autocomplete v-model="cus_id" :items="customerNameList" item-text="name" item-value="id" outlined
                  dense label="Client Name" v-on:change="showCusName"></v-autocomplete>
              </v-col>
            </v-row>
            <v-row class="heightsize70formadvance">
              <v-col cols="12" md="10">
                <v-text-field v-model="customerList[0].address" outlined dense label="Client Address"></v-text-field>
              </v-col>
            </v-row>

            <v-row class="heightsize70formadvance">
              <v-col cols="12" md="10">
                <v-text-field v-model="customerList[0].address_invoice" outlined dense label="Invoice Address"
                  background-color="#F5F5F5" disabled></v-text-field>
              </v-col>
            </v-row>
            <v-row class="heightsize70formadvance">
              <v-col cols="12" md="5">
                <v-text-field v-model="customerList[0].taxid" outlined dense label="Tax ID " background-color="#F5F5F5"
                  disabled></v-text-field>
              </v-col>

              <v-col cols="12" sm="5">
                <v-text-field v-model="customerList[0].branch" outlined dense label="Branch" background-color="#F5F5F5"
                  disabled></v-text-field>
              </v-col>
            </v-row>
            <v-row class="heightsize70formadvance">
              <v-col cols="12" md="3">
                <v-text-field v-model="customerList[0].payment_term" outlined dense
                  label="Payment Term(Day)"></v-text-field>
              </v-col>

              <v-col cols="12" sm="3">
                <v-text-field v-model="customerList[0].currency" outlined dense label="Currency"></v-text-field>
              </v-col>

              <v-col cols="12" sm="3">
                <v-text-field v-model="vat" @keyup="calvatAll(vat)" outlined dense label="Vat(%)"></v-text-field>
              </v-col>

              <v-col cols="12" sm="3">
                <v-select required outlined :items="vat_type_list" v-model="customerList[0].vat_type" item-value="id"
                  item-text="name" label="Vat Type" dense disabled></v-select>
              </v-col>
            </v-row>
            <v-row class="heightsize70formadvance">
              <v-col cols="6" md="6">
                <v-text-field v-model="os_h.remark" outlined dense label="Attention"></v-text-field>
              </v-col>
              <v-col cols="6" md="6">
                <v-text-field v-model="os_h.contact_position" outlined dense label="Contact Position"></v-text-field>
              </v-col>
            </v-row>
            <v-row class="heightsize70formadvance">
              <v-col cols="12" md="4">
                <v-text-field v-model="os_h.po_no" outlined dense label="PO NO."></v-text-field>
              </v-col>

              <!-- PO date -->

              <v-col cols="12" md="4">
                <v-menu v-model="menu" :close-on-content-click="false" :nudge-right="40" transition="scale-transition"
                  offset-y min-width="auto">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field v-model="computedDatePOFormatted" label="PO Date" append-icon="mdi-calendar" readonly
                      dense outlined v-bind="attrs" v-on="on"></v-text-field>
                  </template>
                  <v-date-picker v-model="os_h.po_date" @input="menu = false"></v-date-picker>
                </v-menu>
              </v-col>

              <v-col cols="12" sm="4">
                <v-menu v-model="menu2" :close-on-content-click="false" :nudge-right="40" transition="scale-transition"
                  offset-y min-width="auto">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field v-model="computedDateDeliveryFormatted" label="Delivery Date"
                      append-icon="mdi-calendar" readonly dense outlined v-bind="attrs" v-on="on"></v-text-field>
                  </template>
                  <v-date-picker v-model="os_h.delivery_date" @input="menu2 = false"></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>

            <v-row class="row1 mt-3  pt-3">
              <v-col cols="12" md="7">
                <v-textarea v-model="os_h.additional" solo name="input-7-3" label="Additional information"></v-textarea>
              </v-col>
            </v-row>
            <v-row class="row1 mt-3  pt-3">
              <v-col cols="12" md="2">
                <input type="file" accept="image/.png.jpg" multiple="multiple" @change="previewMultiImage"
                  class="inputsize" ref="file" style="display: none" />
                <v-btn :disabled="sostatus" class="btnuploadfile" @click="$refs.file.click()" elevation="7">
                  <v-icon left dark> mdi-cloud-upload </v-icon>Upload file</v-btn>
              </v-col>
            </v-row>
            <div class="border p-2 mt-3">
              <div v-if="this.filenameattach.length > 0">
                <span v-for="(item, index) in this.filenameattach" :key="index">
                  <a @click="previewattachfile(index)">{{ item }}</a>

                  <v-btn :style="{
                    backgroundColor: '#FFEBEE',
                    color: '#F44336',
                  }" small icon @click="confirmdeleteattachfile(index)">
                    <v-icon small>mdi-close</v-icon>
                  </v-btn>

                  <br />
                </span>
              </div>

              <!-- <template v-if="preview_list.length">
                <p>
                  Preview Image:
                  <span class="red--text">(click image to remove image)</span>
                </p>
                <v-row>
                  <v-col
                    v-for="(item, index) in preview_list"
                    :key="index"
                    class="d-flex child-flex"
                    cols="3"
                  >
                    <v-img
                      :src="item"
                      class="grey lighten-2 mt-3 mb-5"
                      aspect-ratio="1"
                      contain
                      @click="clickremoveimage(index)"
                    >
                    </v-img>
                
                  </v-col>
                </v-row>
              </template> -->
            </div>

            <br />

            <template>
              <template>
                <v-data-table :headers="headers" :items="desserts" sort-by="calories" class="elevation-1 "
                  hide-default-footer>
                  <template v-slot:top>
                    <v-toolbar flat>
                      <!-- <v-divider class="mx-4" inset vertical></v-divider>
                      <v-spacer></v-spacer> -->
                      <v-dialog v-model="dialog" max-width="500px">
                        <!-- <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            color="primary"
                            dark
                            class="mb-2"
                            v-bind="attrs"
                            v-on="on"
                          >
                            New Item
                          </v-btn>
                        </template> -->
                      </v-dialog>
                      <v-dialog v-model="dialogDelete" max-width="400px">
                        <v-card style="padding-top: 30px; padding-bottom: 30px;">
                          <v-card-title style="padding-bottom: 20px;">
                            <v-row justify="center">
                              <span class="red--text text-h5 ju">Delete this item?</span>
                            </v-row>
                          </v-card-title>
                          <br />
                          <v-card-subtitle>
                            <v-row justify="center">
                              <span class="black--text">This action cannot be undone.</span>
                            </v-row>
                          </v-card-subtitle>
                          <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn depressed width="100" class="mr-3 buttonblue" color="red" @click="deleteItemConfirm">
                              Save
                            </v-btn>
                            <v-btn depressed outlined width="100" color="red" @click="closeDelete">
                              Cancel
                            </v-btn>

                            <v-spacer></v-spacer>
                          </v-card-actions>
                        </v-card>
                      </v-dialog>
                    </v-toolbar>
                  </template>

                  <template v-slot:no-data>
                    <v-btn color="primary" @click="initialize">
                      Reset
                    </v-btn>
                  </template>
                  <template v-slot:item.actions="{ item }">
                    <!-- <v-icon small class="mr-2" @click="editItem(item)">
                      mdi-pencil
                    </v-icon> -->

                    <v-btn @click="deleteItem(item)" :style="{
                      backgroundColor: '#9E3B1B',
                      color: 'white',
                    }">
                      <v-icon small>
                        mdi-delete
                      </v-icon>
                    </v-btn>
                  </template>
                </v-data-table>
              </template>

              <div v-if="!sostatus" :style="{
                display: !sostatus ? 'show' : 'none',
              }" class="pl-2 pr-2 pt-2 elevation-1 heightsize55formadvance">
                <template>
                  <v-row>
                    <v-col cols="12" xl="1" lg="1" md="1" sm="1"></v-col>
                    <v-col cols="12" xl="4" lg="4" md="4" sm="4">
                      <v-text-field v-model="editedItem.description" ref="txtDescription" dense outlined
                        label="Description"></v-text-field>
                    </v-col>
                    <v-col cols="12" xl="2" lg="2" md="2" sm="2">
                      <v-text-field v-model="editedItem.unit" ref="txtunit" label="Qty" type="number" min="0" dense
                        outlined></v-text-field>
                    </v-col>
                    <v-col cols="12" xl="2" lg="2" md="2" sm="2">
                      <v-text-field v-model="editedItem.PricePerUnit" ref="txtPricePerUnit" label="Price per Unit"
                        type="number" min="0" dense outlined @keydown.tab="save()"
                        @keydown.enter="save()"></v-text-field>
                    </v-col>
                    <v-col cols="12" xl="3" lg="3" md="3" sm="3"></v-col>
                  </v-row>
                </template>
              </div>
            </template>

            <br />
            <v-row class="heightsize55formadvance">
              <v-col class="text-right" cols="12" md="7"> </v-col>
              <v-col class="text-right" cols="12" md="2">Total </v-col>
              <v-col class="text-right" cols="12" md="3">
                <v-row>
                  <v-col cols="12" md="12">
                    <v-row>
                      <v-col class="text-right" cols="12" md="10">
                        <v-text-field reverse filled disabled outlined dense v-model="sumtotal"></v-text-field>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row class="heightsize55formadvance">
              <v-col class="text-right" cols="12" md="7"> </v-col>
              <v-col class="text-right" cols="12" md="2">VAT ({{ vat }}%) </v-col>
              <v-col class="text-right" cols="12" md="3">
                <v-row>
                  <v-col cols="12" md="12">
                    <v-row>
                      <v-col class="text-right" cols="12" md="10">
                        <v-text-field reverse filled disabled outlined dense v-model="vatCalSum"></v-text-field>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>

            <v-row class="heightsize55formadvance">
              <v-col class="text-right" cols="12" md="7"> </v-col>
              <v-col class="text-right" cols="12" md="2">Grand total </v-col>
              <v-col class="text-right" cols="12" md="3">
                <v-row>
                  <v-col cols="12" md="12">
                    <v-row>
                      <v-col class="text-right" cols="12" md="10">
                        <v-text-field reverse filled disabled outlined dense v-model="sumGrandTotal"
                          class="text-right"></v-text-field>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>

            <br />
            <hr />
            <br />
            <div>
              <v-row>
                <v-col align="center" cols="12" md="12">
                  <v-btn class="mr-5 buttonblue" color="#689ADE" @click="saveSOdraftstatus()">
                    Save Draft
                  </v-btn>
                  <v-btn depressed @click="saveSOsubmit()" class="mr-5 buttonblue">
                    Submit
                  </v-btn>
                </v-col>
              </v-row>

              <!-- <v-row>
                <v-col align="end" cols="12" md="12">
                  <v-btn depressed class="buttonred">
                    Delete form
                  </v-btn>
                </v-col>
              </v-row> -->
            </div>
          </v-card>

          <v-dialog v-model="dialogSendMail" max-width="500px">
            <v-card>
              <v-card-title class="text-h6">Information Saved</v-card-title>
              <v-card-subtitle>
                บันทึกข้อมูลและส่งอีเมล์ถึงผู้อนุมัติสำเร็จ
              </v-card-subtitle>
              <v-card-actions>
                <v-spacer></v-spacer>
                <!-- <v-btn color="blue darken-1" text @click="closeDeleteForm"
                  >Cancel</v-btn
                > -->
                <v-btn color="blue darken-1" text @click="closeDialogSendmail()">OK</v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-dialog v-model="dialogSaveDraft" max-width="30%">
            <v-card>
              <v-card-title primary-title class="justify-center">
                {{ this.messageSaveDraft }}</v-card-title>
              <v-card-actions>
                <v-spacer></v-spacer>
                <!-- <v-btn color="blue darken-1" text @click="closeSaveDraft"
                              >Cancel</v-btn
                            > -->
                <v-btn color="blue darken-1" text @click="closeSaveDraft">OK</v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog v-model="dialogDeleteimage" max-width="400px">
            <v-card style="padding-top: 30px; padding-bottom: 30px;">
              <v-card-title style="padding-bottom: 20px;">
                <v-row justify="center">
                  <span class="red--text text-h5 ju">Delete this item?</span>
                </v-row>
              </v-card-title>
              <br />
              <v-card-subtitle>
                <v-row justify="center">
                  <span class="black--text">This action cannot be undone.</span>
                </v-row>
              </v-card-subtitle>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn depressed width="100" class="mr-3 buttonblue" color="red" @click="removeimage">
                  Save
                </v-btn>
                <v-btn depressed outlined width="100" color="red" @click="closeDeleteimage">
                  Cancel
                </v-btn>
                <!-- <v-btn color="blue darken-1" text @click="closeDeleteimage"
                  >Cancel</v-btn
                >
                <v-btn color="blue darken-1" text @click="removeimage">OK</v-btn> -->
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-dialog v-model="dialogpreviewattachfile" max-width="700px">
            <v-card>
              <v-card-title class="text-h5">
                <v-btn icon @click="closepreviewattachfile">
                  <v-icon large>mdi-close</v-icon>
                </v-btn>
                Preview PDF File</v-card-title>

              <!-- 
                                  :src="pdfdata"
                                  v-for="i in numPages"
                      :key="i"
                      :id="i"
                      :page="i" -->
              <div v-if="checkattachfileapreview" v-for="(item, index) in previewpopupattachfile2" :key="index">
                <pdf :src="item" v-for="i in numPagespreviewattach" :key="i" :id="i" :page="i">
                  <template slot="loading">
                    loading content here...
                  </template>
                </pdf>
              </div>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="closepreviewattachfile">Cancel</v-btn>

                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog v-model="dialogpreviewattachimage" max-width="700px">
            <v-card>
              <v-card-title class="text-h5">
                <v-btn icon @click="closepreviewattachimage">
                  <v-icon large>mdi-close</v-icon>
                </v-btn>
                Preview Image</v-card-title>

              <v-img disabled :src="previewattachimage" class="grey lighten-2 mt-3 mb-5" aspect-ratio="1" contain>
              </v-img>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="closepreviewattachimage">Cancel</v-btn>

                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-dialog v-model="dialogconfirmdeleteattachfile" max-width="400px">
            <v-card style="padding-top: 30px; padding-bottom: 30px;">
              <v-card-title style="padding-bottom: 20px;">
                <v-row justify="center">
                  <span class="red--text text-h5 ju">Delete this item?</span>
                </v-row>
              </v-card-title>
              <br />
              <v-card-subtitle>
                <v-row justify="center">
                  <span class="black--text">This action cannot be undone.</span>
                </v-row>
              </v-card-subtitle>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn depressed width="100" class="mr-3 buttonblue" color="red"
                  @click="deletedialogconfirmdeleteattachfile">
                  Save
                </v-btn>
                <v-btn depressed outlined width="100" color="red" @click="closedialogconfirmdeleteattachfile">
                  Cancel
                </v-btn>
                <!-- <v-btn
                  color="blue darken-1"
                  text
                  @click="closedialogconfirmdeleteattachfile"
                  >Cancel</v-btn
                >
                <v-btn
                  color="blue darken-1"
                  text
                  @click="deletedialogconfirmdeleteattachfile"
                  >OK</v-btn
                > -->
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <SuccessDialog :status="dialogAdd" :text_color="text_color" :title="title" :message="message" />

          <SuccessDialogPush :status="dialogAdd" :text_color="text_color" :title="title" :message="message"
            :link="link" />
        </v-container>
      </v-card-title>
    </v-row>
  </v-row>
</template>

<script>
import api from "@/services/api";
import { server } from "../services/constants";
import StockCard from "@/components/cards/StockCard";
import SuccessDialog from "@/components/cards/SuccessDialog";
import SuccessDialogPush from "@/components/cards/SuccessDialogPush";
import { imageUrl } from "@/services/constants";
import {
  tolocalestringnumber,
  stringcommatonumber,
} from "./computing/tolocalestringnumber";
import unity from "@/unity/unity";
import pdfvuer from "pdfvuer";

export default {
  name: "NewAdvance",
  data() {
    return {
      dialog: false,
      vat_type_list: [{ id: "I", name: "Include Vat" }, { id: "E", name: "Exclude Vat" }],
      menu: false,
      menu2: false,
      os_h: {
        saleorder_id: "",
        customerid: 0,
        remark: "",
        contact_position: "",
        po_no: "",
        po_date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
          .toISOString()
          .substr(0, 10),
        delivery_date: new Date(
          Date.now() - new Date().getTimezoneOffset() * 60000
        )
          .toISOString()
          .substr(0, 10),
        additional: "",
        status: 0,
        image: "",
      },
      add_sod: {
        sales_order_h_id: 0,
        seq: 0,
        item_name: "",
        item_qty: 0,
        item_price: 0,
        item_line_amt: 0,
        user_create: localStorage.getItem(server.USER_ID),
      },
      add_soh: {
        saleorder_id: "",
        customerid: 0,
        delivery_date: "",
        po_no: "",
        po_date: "",
        remark: "",
        additional: "",
        remark: "",
        contact_position: "",
        status: 0,
        created_at: "",
        updated_at: "",
        user_create: localStorage.getItem(server.USER_ID),
        image: "",
        sum_disc: 0,
        sum_line_amt: 0,
      },
      os_d: {
        sales_order_h_id: null,
        item_name: "",
        item_qty: 0,
        item_price: 0,
        item_line_amt: 0,
        user_update: localStorage.getItem(server.USER_ID),
      },
      dialogDeleteimage: false,

      desserts: [
        {
          no: "1",
          detail: "",
          withdrawamount: 0,
        },
      ],
      headers: [
        {
          text: "No.",
          value: "no",
          class: "bg-colorth texttablehcenter ",
          width: "8%",
          align: "start",
          divider: true,
          sortable: false,
        },
        {
          text: "Service/Description",
          align: "center",
          value: "description",
          class: "bg-colorth texttablehcenter",
          width: "35%",
          align: "start",
          divider: true,
          sortable: false,
        },
        {
          text: "Qty",
          value: "unit",
          class: "bg-colorth texttablehcenter ",
          width: "15%",
          divider: true,
          align: "end",
          sortable: false,
        },

        {
          text: "Price Per Unit",
          value: "PricePerUnit",
          class: "bg-colorth texttablehcenter",
          width: "17%",
          divider: true,
          align: "end",
          sortable: false,
        },
        {
          text: "Amount",
          value: "amount",
          class: "bg-colorth texttablehcenter",
          width: "17%",
          divider: true,
          align: "end",
          sortable: false,
        },

        {
          value: "actions",
          class: "bg-colorth texttablehcenter",
          width: "8%",
          divider: true,
          sortable: false,
        },
      ],
      desserts: [],
      editedIndex: -1,
      editedItem: {
        description: "",
        no: 0,
        unit: 0,
        amount: 0,
        PricePerUnit: 0,
      },
      defaultItem: {
        no: 0,
        description: "",
        amount: 0,
        unit: 0,
        PricePerUnit: 0,
      },
      advance_log: {
        module: "SO",
        module_id: 0,
        approve_id: 0,
        approve_status: 0,
        approve_date: null,
      },

      lbl_date_request: false,
      dialogSignature: false,
      dialogSaveDraft: false,
      messageSaveDraft: "",
      paymentType: "",
      bankName: "",
      bankNumber: "",
      chequeNumber: "",
      remark: "",
      sendMail: {
        name: "",
        email: "",
        advance_id: "",
        link: "",
      },
      account: {
        signature: "",
      },
      customerNameList: [],
      customerList: [
        {
          cust_account: "",
        },
      ],
      cus_id: 0,
      datePO: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      dateDelivery: new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10),
      dateCurrent: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      dialogDelete: false,
      no_cus: 0,
      sumtotal: 0.0,
      vatCal: 0,
      vatCalSum: 0.0,
      vat: "0.00",
      sumGrandTotal: 0.0,
      preview_list: [],
      image_list: [],
      dialogAdd: false,
      dialogSendMail: false,
      text_color: "text-h5 green--text text-center",
      title: "green",
      message: "green",
      link: "",
      customer: [],
      sostatus: false,
      customer_code: "",
      filenameattach: [],
      previewpopupattachfile2: [],
      previewpopupattachfile: [],
      checkattachfileapreview: false,
      dialogpreviewattachfile: false,
      dialogpreviewattachimage: false,
      dialogconfirmdeleteattachfile: false,
      numPagespreviewattach: 0,
      previewattachimage: "",
      indexdeleteattachfile: -1,
      getpreview_listattach: [],
      preview_listattach: [],
      image_listattach: [],
    };
  },
  components: {
    pdf: pdfvuer,
    StockCard,
    SuccessDialog,
    SuccessDialogPush,
  },
  computed: {
    version() {
      return this.initial_data;
    },
    formTitle() {
      return this.editedIndex === -1 ? "New Item" : "Edit Item";
    },

    computedDatePOFormatted() {
      return unity.formatDate(this.os_h.po_date);
    },
    computedDateDeliveryFormatted() {
      return unity.formatDate(this.os_h.delivery_date);
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },

  async mounted() {
    // this.$showLoader();
    this.$hideLoader();
    this.$forceUpdate();

    this.loadCustomer();

    // // alert(result.data[0])
    // console.log("testresult")
    //console.log(this.customerNameList)

    const userId = localStorage.getItem(server.USER_ID);
    if (userId && api.isLoggedIn()) {
      // this.$router.push("/");
    } else {
      this.$store.state.isLogged = false;
      this.$router.push("/login");
    }

    const result = await api.getAllCustomerListactiveCompany({
      params: {
        company_id: localStorage.getItem(server.COMPANYID),
      },
    });
    // console.log("result.data : ", JSON.stringify(result.data));
    this.customer = result.data;

    // const resultlist = await api.getCustomers();
    // this.customerNameList = result.data[0];
    this.customerNameList = result.data;
  },
  methods: {
    async getBackList() {
      this.$router.push(`/so-list`);
    },
    async previewattachfile(index) {
      const file = this.image_listattach[index];

      if (!file) {
        console.error('ไม่พบไฟล์ใน image_listattach');
        return;
      }

      if (file instanceof Blob) {
        const blobUrl = URL.createObjectURL(file);
        window.open(blobUrl, '_blank');

        setTimeout(() => URL.revokeObjectURL(blobUrl), 10000);
        return;
      }

      window.open(url, '_blank');
    },
    async getPforpreviewattach(datafile) {
      this.previewpopupattachfile = [];
      let getfile = "";
      getfile = datafile;
      this.previewpopupattachfile.push(pdfvuer.createLoadingTask(`${getfile}`));
      this.previewpopupattachfile.forEach((item, index) => {
        item.then((pdf) => {
          this.numPagespreviewattach = pdf.numPages;
        });
      });
      // console.log(this.previewpopupattachfile);
    },
    async closepreviewattachfile() {
      this.dialogpreviewattachfile = false;
    },
    async closepreviewattachimage() {
      this.dialogpreviewattachimage = false;
    },
    async confirmdeleteattachfile(index) {
      this.indexdeleteattachfile = index;
      this.dialogconfirmdeleteattachfile = true;
    },
    async closedialogconfirmdeleteattachfile() {
      this.indexdeleteattachfile = -1;
      this.dialogconfirmdeleteattachfile = false;
    },
    async deletedialogconfirmdeleteattachfile() {
      this.filenameattach.splice(this.indexdeleteattachfile, 1);
      this.preview_listattach.splice(this.indexdeleteattachfile, 1);
      this.image_listattach.splice(this.indexdeleteattachfile, 1);
      this.getpreview_listattach.splice(this.indexdeleteattachfile, 1);
      this.dialogconfirmdeleteattachfile = false;
    },
    async loadCustomer() {
      let loader = this.$loading.show({
        // Optional parameters
        color: "green",
        loader: "dots",
        container: this.fullPage ? null : this.$refs.formContainer,
        canCancel: false,
        width: 120,
        height: 120,
        backgroundColor: "#ffffff",
        opacity: 0.5,
        zIndex: 999,
        onCancel: this.onCancel,
      });
      const result = await api.getAllCustomerListactiveCompany({
        params: {
          company_id: localStorage.getItem(server.COMPANYID),
        },
      });
      // console.log("result.data : ", JSON.stringify(result.data));
      this.customer = result.data;

      // const resultlist = await api.getCustomers();
      // this.customerNameList = result.data[0];
      this.customerNameList = result.data;
      loader.hide();
    },
    async save() {
      // alert("texttable")
      if (this.editedItem.description == "") {
        // alert("กรุณากรอก Description/Service ");
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Invalid data",
          "Please check your data and try again.",
          "text-h5 red--text text-center"
        );
        this.$refs["txtDescription"].focus();
        return;
      }

      if (
        this.editedItem.unit == undefined ||
        this.editedItem.unit == "0" ||
        this.editedItem.unit == 0
      ) {
        // alert("กรุณากรอกจำนวน");
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Invalid data",
          "Please check your data and try again.",
          "text-h5 red--text text-center"
        );
        this.$refs["txtunit"].focus();
        return;
      }

      if (this.editedItem.unit < 0) {
        // alert("กรุณากรอกจำนวน");
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Invalid data",
          "Please check your data and try again.",
          "text-h5 red--text text-center"
        );
        this.$refs["txtunit"].focus();
        return;
      }

      if (
        this.editedItem.PricePerUnit == undefined ||
        this.editedItem.PricePerUnit == "0" ||
        this.editedItem.PricePerUnit == 0
      ) {
        // alert("กรุณากรอกจำนวนเงินต่อหน่วย");
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Invalid data",
          "Please check your data and try again.",
          "text-h5 red--text text-center"
        );
        this.$refs["txtPricePerUnit"].focus();
        return;
      }

      if (this.editedItem.PricePerUnit < 0) {
        // alert("กรุณากรอกจำนวน");
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Invalid data",
          "Please check your data and try again.",
          "text-h5 red--text text-center"
        );
        this.$refs["txtunit"].focus();
        return;
      }
      // if (this.editedItem.amount == 0 ) {
      //   alert("กรุณากรอกจำนวนเงิน");
      //   this.$refs["txtAmount"].focus();
      //   return;
      // }

      if (this.editedIndex > -1) {
        Object.assign(this.desserts[this.editedIndex], this.editedItem);
      } else {
        // this.desserts.push(this.editedItem);
        this.desserts.push({ ...this.editedItem });
      }
      await this.calvatAll();
      this.close();
    },
    calvatAll(vat) {
      this.sumtotal = 0;
      this.vatCalSum = 0;
      this.sumGrandTotal = 0;
      this.desserts.forEach((item, index) => {
        item.no = index + 1;
        item.unit = stringcommatonumber(item.unit.toString());
        item.PricePerUnit = stringcommatonumber(item.PricePerUnit.toString());
        item.amount = parseFloat(item.unit * item.PricePerUnit).toFixed(2);
        this.sumtotal += parseFloat(item.amount, 10);
        item.unit = tolocalestringnumber(item.unit);
        item.PricePerUnit = tolocalestringnumber(item.PricePerUnit);
        item.amount = tolocalestringnumber(item.amount);
      });

      if (this.customerList[0].vat_type == "E") {
        this.sumtotal = (this.sumtotal).toFixed(2);
        this.vatCalSum = (this.sumtotal * (this.vat / 100)).toFixed(2);
        this.sumGrandTotal = (this.sumtotal * (1 + this.vat / 100)).toFixed(2);
      } else if (this.customerList[0].vat_type == "I") {
        this.sumGrandTotal = this.sumtotal.toFixed(2);
        this.sumtotal = (this.sumGrandTotal / (1 + this.vat / 100)).toFixed(2);
        this.vatCalSum = (this.sumGrandTotal - this.sumtotal).toFixed(2);
      } else {
      }

      this.sumtotal = tolocalestringnumber(this.sumtotal);
      this.vatCalSum = tolocalestringnumber(this.vatCalSum);
      this.sumGrandTotal = tolocalestringnumber(this.sumGrandTotal);
      // this.close();
    },
    setupAlertDialogPush(status, title, message, text_color, link) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
      this.link = link;
    },
    async saveSOdraftstatus() {
      if (this.cus_id == 0 || this.cus_id == "0") {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Invalid data",
          "Please check your data and try again.",
          "text-h5 red--text text-center"
        );
        return;
      }
      const resCheckDoc = await api.checkDocRunning("SO", localStorage.getItem(server.COMPANYID))
      if (resCheckDoc.status == 200) {
        if (resCheckDoc.data[0].resCheckDoc) {
          let loader = this.$loading.show({
            // Optional parameters
            color: "green",
            loader: "dots",
            container: this.fullPage ? null : this.$refs.formContainer,
            canCancel: false,
            width: 120,
            height: 120,
            backgroundColor: "#ffffff",
            opacity: 0.5,
            zIndex: 999,
            onCancel: this.onCancel,
          });

          let formData = new FormData();
          this.image_listattach.forEach((x, index) => {
            formData.append(`file`, x);
          });
          formData.append("customerid", this.cus_id);
          formData.append("customer_address", this.customerList[0].address);
          formData.append("company_id", localStorage.getItem(server.COMPANYID));
          formData.append(
            "customer_inv_address",
            this.customerList[0].address_invoice
          );
          formData.append("payment_term", this.customerList[0].payment_term);
          formData.append("currency", this.customerList[0].currency);
          formData.append("vat", this.vat);
          formData.append("vat_type", this.customerList[0].vat_type);
          formData.append("delivery_date", this.os_h.delivery_date);
          formData.append("po_no", this.os_h.po_no);
          formData.append("po_date", this.os_h.po_date);
          formData.append("remark", this.os_h.remark);
          formData.append("contact_position", this.os_h.contact_position);
          formData.append("additional", this.os_h.additional);
          formData.append(
            "sum_disc",
            stringcommatonumber(this.sumtotal.toString())
          );
          formData.append(
            "sum_tax",
            stringcommatonumber(this.vatCalSum.toString())
          );
          formData.append(
            "sum_line_amt",
            stringcommatonumber(this.sumGrandTotal.toString())
          );
          formData.append("user_create", localStorage.getItem(server.USER_ID));
          formData.append("status", 1);

          const createso_h = await api.createSalesOrderH(formData);
          //alert(createso_h.status);
          if (createso_h.status == 200 || createso_h.status == 201) {
            if (this.desserts.length > 0) {
              this.desserts.forEach((item) => {
                this.add_sod.sales_order_h_id = createso_h.data.id;
                this.add_sod.seq = item.no;
                this.add_sod.item_name = item.description;
                this.add_sod.item_qty = stringcommatonumber(item.unit.toString());
                this.add_sod.item_price = stringcommatonumber(
                  item.PricePerUnit.toString()
                );
                this.add_sod.item_line_amt = stringcommatonumber(item.amount);
                api.addDetailSO(this.add_sod);
              });
            }
            this.advance_log.approve_id = localStorage.getItem(server.USER_ID);
            this.advance_log.approve_status = 1;
            this.advance_log.approve_date = new Date();
            const res_log = await api.addAdvanceLog(this.advance_log);
            // alert(res_log.status)
            if (res_log.status == 200 || res_log.status == 201) {
              //alert("testaddSOD")
              this.$store.state.global_push_dialog = true;
              this.setupAlertDialogPush(
                true,
                "Information Saved",
                "Your information has been saved in draft.",
                "text-h5 green--text text-center",
                "/so-list"
              );
            } else {
              this.$store.state.global_dialog = true;
              this.setupAlertDialog(
                true,
                "Information Saved",
                "ไม่สามารถบันทึกได้",
                "text-h5 red--text text-center"
              );
            }
          } else {
            this.$store.state.global_dialog = true;
            this.setupAlertDialog(
              true,
              "Information Saved",
              "ไม่สามารถบันทึกได้",
              "text-h5 red--text text-center"
            );
          }
          loader.hide();
        } else {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Information Saved",
            "Please kindly check the value of document running.",
            "text-h5 red--text text-center"
          );
          return;
        }
      } else {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Information Saved",
          "ไม่สามารถบันทึกได้",
          "text-h5 red--text text-center"
        );
        return;
      }
    },
    async showCusName() {
      if (!this.cus_id) {
        // รีเซ็ตค่ากลับเป็นค่าเริ่มต้นเมื่อไม่มี cus_id
        this.customerList = [
          {
            cust_account: "",
            address: "",
            address_invoice: "",
            taxid: "",
            branch: "",
            payment_term: "",
            currency: "",
            vat_type: "",
            vat: "",
            contact_name: "",
            contact_position: "",
          },
        ];
        this.vatCal = 0;
        this.customer_code = "";
        this.vat = "";
        this.os_h.remark = "";
        this.os_h.contact_position = "";
        return;
      }
      await this.$showLoader();
      const result = await api.getCustomersByIdForSO(this.cus_id);

      if (result.data && result.data.length > 0) {
        // console.log(result.data[0])
        this.customerList = result.data;
        this.vatCal = parseInt(this.customerList[0].vat);
        this.customer_code = this.cus_id;
        this.vatCal = parseInt(this.customerList[0].vat);
        this.vat = this.customerList[0].vat;
        this.os_h.remark = this.customerList[0].contact_name;
        this.os_h.contact_position = this.customerList[0].contact_position == null ? "" : this.customerList[0].contact_position;
      }


      await this.$hideLoader();
    },
    async showCode() {
      if (!this.customer_code) {
        // รีเซ็ตค่ากลับเป็นค่าเริ่มต้นเมื่อไม่มี customer_code
        this.customerList = [
          {
            cust_account: "",
            address: "",
            address_invoice: "",
            taxid: "",
            branch: "",
            payment_term: "",
            currency: "",
            vat_type: "",
            vat: "",
            contact_name: "",
            contact_position: "",
          },
        ];
        this.vatCal = 0;
        this.cus_id = 0;
        this.vat = "";
        this.os_h.remark = "";
        this.os_h.contact_position = "";
        return;
      }
      await this.$showLoader();
      const result = await api.getCustomersByIdForSO(this.customer_code);

      if (result.data && result.data.length > 0) {
        // console.log(result.data[0])
        this.customerList = result.data;
        this.vatCal = parseInt(this.customerList[0].vat);
        this.cus_id = this.customer_code;
        this.vatCal = parseInt(this.customerList[0].vat);
        this.vat = this.customerList[0].vat;
        this.os_h.remark = this.customerList[0].contact_name;
        this.os_h.contact_position = this.customerList[0].contact_position == null ? "" : this.customerList[0].contact_position;
      }


      await this.$hideLoader();
    },
    async saveSOsubmit() {
      if (this.cus_id == 0 || this.cus_id == "0") {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Invalid data",
          "Please check your data and try again.",
          "text-h5 red--text text-center"
        );
        return;
      }
      const resCheckDoc = await api.checkDocRunning("SO", localStorage.getItem(server.COMPANYID))
      if (resCheckDoc.status == 200) {
        // console.log(resCheckDoc.data)
        if (resCheckDoc.data[0].resCheckDoc) {
          let loader = this.$loading.show({
            // Optional parameters
            color: "green",
            loader: "dots",
            container: this.fullPage ? null : this.$refs.formContainer,
            canCancel: false,
            width: 120,
            height: 120,
            backgroundColor: "#ffffff",
            opacity: 0.5,
            zIndex: 999,
            onCancel: this.onCancel,
          });

          let formData = new FormData();
          this.image_listattach.forEach((x, index) => {
            formData.append(`file`, x);
          });

          formData.append("customerid", this.cus_id);
          formData.append("customer_address", this.customerList[0].address);
          formData.append("company_id", localStorage.getItem(server.COMPANYID));
          formData.append(
            "customer_inv_address",
            this.customerList[0].address_invoice
          );
          formData.append("payment_term", this.customerList[0].payment_term);
          formData.append("currency", this.customerList[0].currency);
          formData.append("vat", this.vat);
          formData.append("vat_type", this.customerList[0].vat_type);
          formData.append("delivery_date", this.os_h.delivery_date);
          formData.append("po_no", this.os_h.po_no);
          formData.append("po_date", this.os_h.po_date);
          formData.append("remark", this.os_h.remark);
          formData.append("contact_position", this.os_h.contact_position);
          formData.append("additional", this.os_h.additional);
          formData.append(
            "sum_disc",
            stringcommatonumber(this.sumtotal.toString())
          );
          formData.append(
            "sum_tax",
            stringcommatonumber(this.vatCalSum.toString())
          );
          formData.append(
            "sum_line_amt",
            stringcommatonumber(this.sumGrandTotal.toString())
          );
          formData.append("user_create", localStorage.getItem(server.USER_ID));
          formData.append("status", 2);

          const createso_h = await api.createSalesOrderH(formData);
          //alert(createso_h.status);
          if (createso_h.status == 200 || createso_h.status == 201) {
            if (this.desserts.length > 0) {
              this.desserts.forEach((item) => {
                this.add_sod.sales_order_h_id = createso_h.data.id;
                this.add_sod.seq = item.no;
                this.add_sod.item_name = item.description;
                this.add_sod.item_qty = stringcommatonumber(item.unit.toString());
                this.add_sod.item_price = stringcommatonumber(
                  item.PricePerUnit.toString()
                );
                this.add_sod.item_line_amt = stringcommatonumber(item.amount);
                api.addDetailSO(this.add_sod);
              });
            }
            this.advance_log.approve_id = localStorage.getItem(server.USER_ID);
            this.advance_log.approve_status = 2;
            this.advance_log.approve_date = new Date();
            const res_log = await api.addAdvanceLog(this.advance_log);
            if (res_log.status == 200 || res_log.status == 201) {
              this.$store.state.global_push_dialog = true;
              this.setupAlertDialogPush(
                true,
                "Submitted",
                "Information submit and sent to Approver.",
                "text-h5 green--text text-center",
                "/so-list"
              );
            } else {
              this.$store.state.global_dialog = true;
              this.setupAlertDialog(
                true,
                "Information Saved",
                "ไม่สามารถบันทึกได้",
                "text-h5 red--text text-center"
              );
            }
          } else {
            this.$store.state.global_dialog = true;
            this.setupAlertDialog(
              true,
              "Information Saved",
              "ไม่สามารถบันทึกได้",
              "text-h5 red--text text-center"
            );
          }
          loader.hide();
        } else {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Information Saved",
            "Please kindly check the value of document running.",
            "text-h5 red--text text-center"
          );
          return;
        }
      } else {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Information Saved",
          "ไม่สามารถบันทึกได้",
          "text-h5 red--text text-center"
        );
        return;
      }

    },
    async closeDelete() {
      await this.calvatAll();
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    setupAlertDialog(status, title, message, text_color) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
    },

    initialize() { },
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    deleteItem(item) {
      this.editedIndex = this.desserts.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },
    deleteItemConfirm() {
      this.desserts.splice(this.editedIndex, 1);
      this.closeDelete();
    },
    previewImage: function (event) {
      var input = event.target;
      if (input.files) {
        var reader = new FileReader();
        reader.onload = (e) => {
          this.preview = e.target.result;
        };
        this.image = input.files[0];
        reader.readAsDataURL(input.files[0]);
      }
    },
    previewMultiImage: function (event) {
      this.filenameattach = [];
      var input = event.target;
      var count = input.files.length;
      var index = 0;
      if (input.files) {
        while (count--) {
          var reader = new FileReader();
          reader.onload = (e) => {
            // this.preview_list.push(e.target.result);
            this.getpreview_listattach.push(e.target.result);
            this.preview_listattach.push(e.target.result);
          };
          if (
            input.files[index].type === "application/pdf" ||
            input.files[index].type.split("/")[0] === "image"
          ) {
            this.image_listattach.push(input.files[index]);
            reader.readAsDataURL(input.files[index]);
          }
          index++;
        }
      }
      // console.log(this.image_list);
      this.image_listattach.forEach((x) => {
        this.filenameattach.push(x.name);
      });
    },
    reset: function () {
      this.image = null;
      this.preview = null;
      this.image_list = [];
      this.preview_list = [];
    },
    clickremoveimage(index) {
      this.indeximage = index;
      this.dialogDeleteimage = true;
    },
    async removeimage(index) {
      this.preview_list.splice(this.indeximage, 1);
      this.image_list.splice(this.indeximage, 1);

      this.dialogDeleteimage = false;
    },
    closeDeleteimage() {
      this.indeximage = null;
      this.dialogDeleteimage = false;
    },
    closeSaveDraft() { },
  },
  async beforeCreate() {
    // console.log("beforeCreate");
    this.$store.state.navMenu = true;

    // this.showdefaultsignature();
  },
  async created() {
    // this.showdefaultsignature();
  },
};
</script>

<style scoped>
.text-left {
  color: aliceblue;
}

.v-btn:not(.v-btn--round).v-size--default.buttonblue {
  background-color: #1d2442;
  color: white;
}

.v-btn:not(.v-btn--round).v-size--default.buttonred {
  background-color: #9e3b1b;
  color: white;
}

.v-autocomplete.v-input>.v-input__control>.v-input__slot {
  min-height: 10px;
}

.widthsizeformadvance {
  width: 60%;
}

.bd-block-tb {
  border-block: 1px solid gray;
  writing-mode: horizontal-tb;
  margin-left: 0%;
  margin-right: 0%;
  height: 45px;
}

.bd-block-lr {
  border-block: 1px solid gray;
  writing-mode: vertical-lr;
  margin-left: 0%;
  margin-right: 0%;
  height: 45px;
}

.widthsize80formadvance {
  width: 80%;
}

.heightsize55formadvance {
  height: 55px;
}

.heightsize80performadvance {
  height: 60%;
}

.heightsize70formadvance {
  height: 70px;
}

.widthsize8055formadvance {
  width: 80px;
  height: 55px;
}

.advance-text-height {
  height: 70px;
}

.some-other-style {
  background: blue;
}

.my-header-style {
  color: #ffffff !important;
  background: #515151;
}

.data-table-button {
  color: #9e3b1b;
}

.my-header2-style {
  color: #ffffff !important;
  background: #515151;
  width: 120px;
}

.my-header3-style {
  color: #ffffff !important;
  background: #515151;
  width: 80px;
}

.my-header4-style {
  color: #ffffff !important;
  background: #515151;
  width: 150px;
}

.btnuploadfile {
  border: 2px solid;
}
</style>
